module.exports = __webpack_public_path__ + "media/images/application/favicon/logo-0c978872ce2b95ae34dd06d69df4c840.png";